/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Manager_TitleInputs */



/**
* | output |
* | --- |
* | "KNP Terminology Manager" |
*
* @param {Knp_Manager_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_manager_title = /** @type {((inputs?: Knp_Manager_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Manager_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gestionnaire de terminologie KNP")
	if (locale === "de") return /** @type {LocalizedString} */ ("KNP Terminologiemanager")
	if (locale === "it") return /** @type {LocalizedString} */ ("Responsabile della terminologia KNP")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Менеджер по терминологии KNP")
	if (locale === "es") return /** @type {LocalizedString} */ ("Administrador de terminología de KNP")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("KNP术语管理器")
	if (locale === "ja") return /** @type {LocalizedString} */ ("KNP用語マネージャー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("केएनपी शब्दावली प्रबंधक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gerente de Terminologia do KNP")
	return /** @type {LocalizedString} */ ("KNP Terminology Manager")
});